// extracted by mini-css-extract-plugin
export default {"root":"SectionedLogicForm_root__XkHaS"};